import db from "../db/database";
import { fetchFromBusinessCentral } from "../utils/businessCentralUtils";

/**
 * Busca una factura en BC utilizando el Id_TPV
 */
export const findInvoiceInBCByIdTpv = async (idTpv) => {
    try {
        if (!idTpv) return null;

        const url =
            `salesInvoice?$filter=Id_TPV eq '${idTpv}'`;

        const response = await fetchFromBusinessCentral(url);

        if (!response?.length) {
            return null;
        }

        return response[0];
    } catch (error) {
        console.error(
            `Error buscando factura en BC por Id_TPV ${idTpv}`,
            error
        );

        return null;
    }
};

/**
 * Libera una factura que quedó bloqueada sincronizando
 */
export const releaseStuckInvoice = async (invoiceId) => {
    try {
        await db.invoices.update(invoiceId, {
            syncing: false,
            syncStartTime: null,
        });
    } catch (error) {
        console.error(
            `Error liberando factura ${invoiceId}`,
            error
        );
    }
};

/**
 * Reconciliar factura local con BC
 */
export const reconcileInvoiceWithBC = async (
    localInvoice,
    bcInvoice
) => {
    try {
        let invoiceToUpdate = {
            Pre_Assigned_No: bcInvoice.No || null,
            systemId: bcInvoice.SystemId || null,

            syncStage: "header",
            pendingSync: 1,
            syncing: false,
            syncStartTime: null,
            lastSynced: new Date(),
        }

        let lines = await fetchFromBusinessCentral(`LinesSalesInvoice?$filter=Document_No eq '${bcInvoice.No}'`);

        if (lines.length > 0) {
            invoiceToUpdate.syncStage = "lines";
        }

        let paymentLines = await fetchFromBusinessCentral(`DetallePagoFactura?$filter=Document_No_ eq '${bcInvoice.No}'`);

        if (paymentLines.length > 0) {
            invoiceToUpdate.syncStage = "payments";
            invoiceToUpdate.pendingSync = 0;
        }

        await db.invoices.update(localInvoice.id, invoiceToUpdate);

        console.warn(
            `Factura reconciliada desde BC: ${bcInvoice.No}`
        );

        return true;
    } catch (error) {
        console.error(
            `Error reconciliando factura ${localInvoice.id}`,
            error
        );

        return false;
    }
};

/**
 * Recovery principal
 *
 * Busca facturas:
 * - pendientes
 * - con Id_TPV
 * - sin No asignado
 *
 * y verifica si ya existen en BC.
 */
export const recoverInterruptedInvoices = async () => {
    try {
        console.warn(
            "Iniciando recovery de facturas interrumpidas..."
        );

        const interruptedInvoices = await db.invoices
            .filter(
                (invoice) =>
                    (invoice.pendingSync === 1 || invoice.pendingSync === true) &&
                    (invoice.syncing === 1 || invoice.syncing === true) &&
                    invoice.Id_TPV &&
                    !invoice.deleted
            )
            .toArray();

        if (!interruptedInvoices.length) {
            console.warn(
                "No hay facturas pendientes para recovery"
            );

            return;
        }

        console.warn(
            `Facturas encontradas para recovery: ${interruptedInvoices.length}`
        );

        for (const invoice of interruptedInvoices) {
            try {
                console.warn(
                    `Verificando factura ${invoice.id} - ${invoice.Id_TPV}`
                );

                // Buscar en BC
                const bcInvoice =
                    await findInvoiceInBCByIdTpv(
                        invoice.Id_TPV
                    );

                // Existe en BC
                if (bcInvoice) {
                    await reconcileInvoiceWithBC(
                        invoice,
                        bcInvoice
                    );

                    continue;
                }

                // NO existe en BC
                // liberar lock local
                await releaseStuckInvoice(invoice.id);

                console.warn(
                    `Factura ${invoice.id} no existe en BC. Lock liberado.`
                );
            } catch (error) {
                console.error(
                    `Error procesando recovery de factura ${invoice.id}`,
                    error
                );
            }
        }

        console.warn(
            "Recovery de facturas finalizado"
        );
    } catch (error) {
        console.error(
            "Error general en recoverInterruptedInvoices",
            error
        );
    }
};

